import { Component , OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Api, Session } from '../../services/index';
import {ProviderBio } from '../../models/provider';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'page-provider-bio',
  templateUrl: 'provider-bio.component.html',
  styleUrls: ['provider-bio.component.css']
})

export class ProviderBioPage implements OnInit {
  providerBios: Array<ProviderBio>;
  parms: any;
  lob: any;
  hasBios: boolean;
  intakeState: string;
  patientId: number;
  loading = false;

  constructor(private route: ActivatedRoute, private router: Router,
    private api: Api, public session: Session) {
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
    this.providerBios = new Array<ProviderBio>();
    this.hasBios = false;
    this.lob = this.session.intakeLob;
    this.intakeState = this.session.clientIntake.currentState;
  }

  ngOnInit() {
    this.loading = true;
    
    this.api.getProviderBioByBhType(this.lob ,this.intakeState, this.session.intakeBhType).subscribe(bios => {
      this.providerBios = bios;
      if (this.providerBios.length > 0) {
        this.providerBios.forEach(item => {
          if(item.avatarBase64){
            let _base64 = item.avatarBase64.toString();
            item.avatarBase64 = "data:image/png;base64," + _base64;
          }
        });
        this.hasBios = true;
      }else{
        this.hasBios = false;
        this.router.navigate(['/exam-appointment/' + this.patientId ]);
      }
      this.loading = false;
    }, (error) => {
      this.loading = false;
    })
    
  }

  getAppointmentsForProvider(provider) {
    let _providerId = Number(provider.providerUserId);

    console.log('getAppointmentsForProvider:', provider);
    this.session.providerBio = provider;
    this.session.intakeRequestedProviderId = provider.providerUserId;
    this.router.navigate(['/provider-detail-page/' +   this.patientId]);
  }
  skipBio(){
    this.hasBios = false;
    this.router.navigate(['/exam-appointment/' + this.patientId ]);
  }

}

